export default __webpack_public_path__ + "static/media/ok_in.47bd9212.png";